var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitles-parent",class:{'user-active':_vm.userActive}},_vm._l((_vm.cueTexts),function(text,i){return _c('span',{key:i,staticClass:"cue-text"},[_vm._v(_vm._s(text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }